import { atom } from 'jotai';

export const sourcingSearchPromptAtom = atom<string | null>(null);
